import { render, staticRenderFns } from "./CustomerOutstandingOnAccount.vue?vue&type=template&id=ebf28e9c&scoped=true&"
import script from "./CustomerOutstandingOnAccount.vue?vue&type=script&lang=js&"
export * from "./CustomerOutstandingOnAccount.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOutstandingOnAccount.vue?vue&type=style&index=0&id=ebf28e9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf28e9c",
  null
  
)

export default component.exports